import { render, staticRenderFns } from "./WxGroup.vue?vue&type=template&id=56fc630a&"
import script from "./WxGroup.vue?vue&type=script&lang=js&"
export * from "./WxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports